import { Component } from '@angular/core';

@Component({
  selector: 'wp-chat',
  standalone: true,
  templateUrl: './chat.component.html',
  styleUrl: 'chat.component.scss',
})
export class ChatComponent {}
